module.exports = __webpack_public_path__ + "img/25-small.fd9515bb.png";